/* Hero: meerdere hero's met swipe, pijlen en puntjes, en het naamveld (gebruikt window.LapusiePet). */
if (typeof customElements !== 'undefined' && !customElements.get('hero-banner')) {
  customElements.define(
    'hero-banner',
    class HeroBanner extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-hero-track]');
        this.slides = this.track ? Array.prototype.slice.call(this.track.children) : [];
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-hero-dot]'));
        this.index = 0;
        if (this.slides.length > 1) this.initCarousel();
        this.initPet();
      }

      disconnectedCallback() {
        if (this.onPetChange) document.removeEventListener('lapusie:pet-change', this.onPetChange);
      }

      initCarousel() {
        var self = this;
        var ticking = false;
        this.track.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              ticking = false;
              self.setActive(Math.round(self.track.scrollLeft / self.track.clientWidth));
            });
          },
          { passive: true }
        );
        var prev = this.querySelector('[data-hero-prev]');
        var next = this.querySelector('[data-hero-next]');
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
        this.dots.forEach(function (dot) {
          dot.addEventListener('click', function () { self.go(Number(dot.getAttribute('data-hero-dot'))); });
        });
        this.setActive(0);
      }

      go(target) {
        var count = this.slides.length;
        var i = (target + count) % count;
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      }

      setActive(i) {
        if (i < 0 || i >= this.slides.length) return;
        this.index = i;
        this.dots.forEach(function (dot, n) {
          if (n === i) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      initPet() {
        var root = this.querySelector('[data-hero-pet]');
        if (!root) return;
        if (!window.LapusiePet) {
          root.hidden = true;
          return;
        }
        var form = root.querySelector('[data-hero-pet-form]');
        var input = root.querySelector('[data-hero-pet-input]');
        var saved = root.querySelector('[data-hero-pet-saved]');
        var greeting = root.querySelector('[data-hero-pet-greeting]');
        var edit = root.querySelector('[data-hero-pet-edit]');
        var editing = false;

        function render() {
          var pet = window.LapusiePet.get();
          var showSaved = !!pet && !editing;
          form.hidden = showSaved;
          saved.hidden = !showSaved;
          if (showSaved) {
            greeting.textContent = (greeting.getAttribute('data-template') || '{name}').replace('{name}', pet.name);
          } else if (pet && !input.value) {
            input.value = pet.name;
          }
        }

        form.addEventListener('submit', function (event) {
          event.preventDefault();
          editing = false;
          var ok = window.LapusiePet.set(input.value, (window.LapusiePet.get() || {}).species || '');
          if (!ok) input.focus();
        });
        edit.addEventListener('click', function () {
          editing = true;
          render();
          input.focus();
          input.select();
        });
        this.onPetChange = function () {
          editing = false;
          render();
        };
        document.addEventListener('lapusie:pet-change', this.onPetChange);
        render();
      }
    }
  );
}
